import { z } from "zod";
import { FirestoreTimestampSchema } from "./common.schema";

export const ReviewStatusSchema = z.enum([
  "draft",
  "ready_for_review",
  "approved",
  "rejected",
  "conflict",
]);

export const PublishStatusSchema = z.enum([
  "not_requested",
  "queued",
  "publishing",
  "published",
  "failed",
]);

export const VersionOriginSchema = z.enum([
  "sync",
  "edit",
  "create",
  "conflict",
  "manual_edit",
]);

export const WordPressVersionSchema = z.object({
  review_status: ReviewStatusSchema.nullable().default(null),
  publish_status: PublishStatusSchema.nullable().default(null),
  origin: VersionOriginSchema.optional(),
  wp_id: z.number().nullable().optional(),
  wp_link: z.string().default(""),
  wp_title: z.string().default(""),
  wp_content: z.string().default(""),
  wp_slug: z.string().default(""),
  wp_excerpt: z.string().default(""),
  wp_type: z.enum(["page", "post"]),
  wp_status: z.string(),
  wp_template: z.string().default(""),
  wp_comment_status: z.string().default(""),
  wp_author: z.number().nullable().optional(),
  wp_categories: z.array(z.number()).default([]),
  wp_tags: z.array(z.number()).default([]),
  wp_parent_id: z.number().nullable().default(null),
  wp_menu_order: z.number().default(0),
  wp_featured_media: z.number().nullable().default(null),
  wp_meta: z.record(z.string(), z.unknown()).optional(),
  wp_raw_data: z.record(z.string(), z.unknown()).optional(),
  created_at: FirestoreTimestampSchema.optional(),
  base_version_id: z.string().nullable().default(null),
  base_wp_modified: FirestoreTimestampSchema.optional(),
  conflict_created_version_path: z.string().nullable().default(null),
  conflict_source_version_path: z.string().nullable().default(null),
  publish_job_id: z.string().nullable().default(null),
  approved_at: FirestoreTimestampSchema.optional(),
  published_at: FirestoreTimestampSchema.optional(),
  synced_at: FirestoreTimestampSchema.optional(),
  wp_modified: FirestoreTimestampSchema.optional(),
  generation_error: z.string().nullable().optional(),
  publish_error: z.string().nullable().optional(),
  // Which conversation turn produced this document, when the assistant made it.
  // Backend-written only (these collections are `allow write: if false`), so the
  // value is trustworthy; null on anything a member made by hand and on
  // documents written before the fields existed.
  source_thread_id: z.string().nullable().optional(),
  source_message_id: z.string().nullable().optional(),
});

export type ReviewStatus = z.infer<typeof ReviewStatusSchema>;
export type PublishStatus = z.infer<typeof PublishStatusSchema>;
export type VersionOrigin = z.infer<typeof VersionOriginSchema>;
export const WordPressVersionEntitySchema = WordPressVersionSchema.extend({
  id: z.string(),
});
export type WordPressVersion = z.infer<typeof WordPressVersionEntitySchema>;

export const parseWordPressVersion = (data: unknown): WordPressVersion =>
  WordPressVersionEntitySchema.parse(data);
